import { accessCode } from "./all";

export const SUMBER_PENJUALAN_SIMRS = 1;
export const SUMBER_PENJUALAN_OTOMATIS_REGISTRASI = 4;

/**
 * Status Tagihan
 */

export const STATUS_OPEN_DRAFT_TAGIHAN = 0;
export const STATUS_KUNCI_TAGIHAN = 1;
export const STATUS_TUTUP_TAGIHAN = 2;

export const SHOW_BUKA_TRANSAKSI = {
  label: "BUKA TRANSAKSI",
  color: "green",
  state: false,
};

export const SHOW_UPDATE_TRANSAKSI = {
  label: "UPDATE TRANSAKSI",
  color: "green",
  state: false,
};

export const SHOW_BUKA_KUNCI_TRANSAKSI = {
  label: "BUKA KUNCI TRANSAKSI",
  color: "warning",
  state: false,
};

export const SHOW_BUKA_TUTUP_TRANSAKSI = {
  label: "BUKA TUTUP TRANSAKSI",
  color: "warning",
  state: false,
};

export const SHOW_KUNCI_TRANSAKSI = {
  label: "KUNCI TRANSAKSI",
  color: "warning",
  state: false,
};

export const SHOW_TUTUP_TRANSAKSI = {
  label: "TUTUP TRANSAKSI",
  color: "primary-cyan",
  state: false,
};

export const SHOW_KUNCI_TUTUP_KUNJUNGAN = {
  label: "KUNCI TRANSAKSI & SELESAIKAN KUNJUNGAN",
  color: "warning",
  state: false,
};

export const RESET_BUTTON_FORCE = {
  state: false,
  message: "",
  type: 1, // 1 Untuk Kunci Tagihan saja, 2 Untuk kunci tagihan dan selesaikan kunjungan,
  force: false,
  clicked: false,
};

export const LIST_URL_BILLING = {
  rikjang: {
    jenis_rikjang: "/master/rikjang/js_rikjang/list",
    jenis_harga: "/wmsfarmasi/master/harga/list",
    tarif_cbg: "/wmsfarmasi/master/tarifCbg/list",
    gudang: `/wmsfarmasi/gudang/list?access_code=${accessCode.gudang_farmasi}`,
  },

  fasilitas: {
    list: `/master/fasilitas/ms_fasilitas/get-options`,
    jenis_fasilitas: "/master/fasilitas/js_fasilitas/list",
    jenis_harga: "/wmsfarmasi/master/harga/list",
    tarif_cbg: "/wmsfarmasi/master/tarifCbg/list",
    gudang: `/wmsfarmasi/gudang/list?access_code=${accessCode.gudang_farmasi}`,
  },
};
